import { render } from "./LoadingPage.vue?vue&type=template&id=40cf846d"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__